import { IAddressInputAddress } from '@opendoor/cinderblocks/growth/AddressInput/AddressInput';

import { CONSUMER_FE_URL } from '../globals';

import { analytics, Sentry } from '@opendoor/observability';
import * as api from './';
import { getAnonymousId } from '../shared/trackers';

interface IPathParams {
  token: string;
  page: string;
  inApp?: boolean;
}

const sellerGlobalPagePath = ({ token, page, inApp = false }: IPathParams) => {
  let path = `/seller-lead/${token}/p/${page}`;
  if (inApp) {
    path = `${path}?app=1`;
  }
  return path;
};

export const bffSellerGlobalPagePath = ({ token, page, inApp = false }: IPathParams) => {
  return CONSUMER_FE_URL + sellerGlobalPagePath({ token, page, inApp });
};

export const getSellerFlowUUID = () => {
  const fragments = window.location.search.match(/sfuuid=([-\w]+)/);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const getUrlParam = (paramName: string) => {
  const regExp = new RegExp(`${paramName}\\=([\\w-_]+)`);
  const fragments = window.location.search.match(regExp);
  if (!fragments) {
    return undefined;
  }
  return fragments[1];
};

export const getSellerFlowName = () => {
  return getUrlParam('sfname');
};

export const getCovid19Whitelist = () => {
  return getUrlParam('covid19_whitelist') === 'true';
};

export const getCustomExperimentEntityId = () => {
  return getUrlParam('experiment_entity_id');
};

export const getChannelOverride = () => {
  return getUrlParam('channel_override')?.toUpperCase();
};

export const startAddressVerification = async ({
  address,
  channel,
  trackingKeywords,
  inputLocation,
  onSuccess,
  isTradeInDashboard,
}: {
  address: IAddressInputAddress;
  channel?: string;
  trackingKeywords?: string;
  inputLocation?: string;
  onSuccess?: (token: string, pdpUrl?: string) => void;
  isTradeInDashboard?: boolean;
}) => {
  analytics.trackEvent('inputting', 'address', 'verifying', {
    ...address,
    inputLocation,
  });

  const options = {
    channel: getChannelOverride() || channel,
    covid19Whitelist: getCovid19Whitelist(),
    experiment_entity_id: getCustomExperimentEntityId() || getAnonymousId(),
    isTradeInDashboard,
    seller_flow_name_override: getSellerFlowName(),
    seller_flow_uuid_override: getSellerFlowUUID(),
    trackingKeywords,
  };
  const error = await api
    .createSellerInput(address, options)
    .then(
      ({
        data: {
          reception: {
            createSellerInputWithTrackingDataFromCookies: {
              sellerInput: {
                uuid,
                pdpUrl,
                address: { postalCode },
              },
            },
          },
        },
      }) => {
        analytics.register({ 'Offer ID': uuid, 'Offer Postal Code': postalCode });
        onSuccess && onSuccess(uuid, pdpUrl);
      },
    )
    .catch((e) => {
      analytics.trackEvent('lead', 'failed');
      Sentry.captureException(e);
      return e;
    });

  return error;
};
